<hlm-popover align="end" class="language-switcher" (stateChanged)="onStateChanged($event)">
  <button
    type="button"
    hlmPopoverTrigger
    class="language-switcher__trigger"
    [attr.aria-label]="'language-switcher.change-language' | translate"
    [attr.aria-expanded]="isPopoverOpen()"
    [attr.aria-controls]="popoverId"
    aria-haspopup="menu"
  >
    {{ selectedLanguage().code | uppercase }}
  </button>

  <hlm-popover-content *hlmPopoverPortal="let ctx">
    <div
      [id]="popoverId"
      class="language-switcher__options"
      role="menu"
      [attr.aria-label]="'language-switcher.select-language' | translate"
    >
      @for (lang of languages; track lang.code) {
        <button
          type="button"
          class="language-switcher__option"
          [class.language-switcher__option--active]="selectedLanguage().code === lang.code"
          role="menuitemradio"
          [attr.aria-checked]="selectedLanguage().code === lang.code"
          [attr.aria-label]="lang.name"
          (click)="onLanguageChange(lang, ctx)"
        >
          @if (selectedLanguage().code === lang.code) {
            <ocp-themed-icon name="checkmark.svg" class="language-switcher__option-check" />
          } @else {
            <span class="language-switcher__option-check-placeholder"></span>
          }
          <span class="language-switcher__option-name">{{ lang.name }}</span>
        </button>
      }
    </div>
  </hlm-popover-content>
</hlm-popover>
